<template>
  <NuxtLink
    class="cta"
    v-if="_blok"
    :to="getUrl(_blok?.to)"
    :target="_blok?.openInNewTab ? '_blank' : null"
  >
    <slot v-if="hasSlot('default')"></slot>
    <div
      class="wrap"
      v-else
    >
      <CtaButton :layout="_blok.layout">{{ _blok.label }}</CtaButton>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})
const emits = defineEmits(["loaded"])
const { app, debug, browser } = useStores()
const { $gsap, $ScrollTrigger } = useNuxtApp()

onMounted(() => {
  emits("loaded")
})

const getUrl = (to) => {
  let u = to.cached_url || to.url
  if (to.anchor) {
    u += `#${to.anchor}`
  }
  if (!u.startsWith("http") && !u.startsWith("/")) u = `/${u}`
  // console.log(1000, u)
  return u
}

const _blok = computed(() => {
  if (Array.isArray(props.blok)) {
    return props.blok[0]
  }
  return props.blok
})

const slots = useSlots()
const hasSlot = (name) => {
  return !!slots[name]
}
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.cta {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
}
</style>
